export const dailyCollections = [
  {
    slug: "daily-2026-09-10",
    date: "2026-09-10",
    weekday: "周四",
    title: "每日合集·9月10日｜程亦野苏念回应、顾言之定档国庆",
    summary:
      "今天的话题集中在两条主线上：一是程亦野与苏念三度同框后双方工作室的回应，二是顾言之新片定档国庆并放出长镜头预告。",
    highlights: [
      "程亦野苏念同框话题冲上热搜前排",
      "顾言之新片定档国庆，长镜头预告刷屏",
      "综艺救场名场面被剪进正片",
    ],
    articleSlugs: [
      "cheng-yiye-su-nian-santong-kuang",
      "gu-yanzhi-new-film-dingdang",
      "baixi-variety-save-scene",
      "lin-wanxing-red-carpet-look",
    ],
  },
  {
    slug: "daily-2026-09-09",
    date: "2026-09-09",
    weekday: "周三",
    title: "每日合集·9月9日｜红毯造型盘点 + 综艺名场面合集",
    summary:
      "今天的看点偏轻松：林晚星的红毯换风格成为造型类讨论第一，白溪的临场救场则贡献了当晚传播最广的综艺画面。",
    highlights: [
      "林晚星复古缎面长裙讨论度第一",
      "白溪一句话救场被大量二创",
      "短剧选角倾向引发行业讨论",
    ],
    articleSlugs: [
      "lin-wanxing-red-carpet-look",
      "baixi-variety-save-scene",
      "short-drama-new-players",
      "lu-zhiyao-tour-finale",
    ],
  },
  {
    slug: "daily-2026-09-08",
    date: "2026-09-08",
    weekday: "周二",
    title: "每日合集·9月8日｜巡演收官返场 + 短剧赛道观察",
    summary:
      "陆知遥巡演收官站返场加唱四首，成为昨天演出类话题的最高点；行业方面，短剧选角与片酬结构的变化被反复讨论。",
    highlights: [
      "收官站返场时长接近二十分钟",
      "竖屏短剧选角标准悄然变化",
      "温可官宣进组古装大制作",
    ],
    articleSlugs: [
      "lu-zhiyao-tour-finale",
      "short-drama-new-players",
      "wen-ke-costume-drama-join",
      "jiang-zhao-new-drama-start",
    ],
  },
  {
    slug: "daily-2026-09-07",
    date: "2026-09-07",
    weekday: "周一",
    title: "每日合集·9月7日｜街拍澄清与开机路透同期出现",
    summary:
      "唐芷的夜间街拍引来讨论，粉丝团连夜澄清；另一边江照的新剧开机路透也带来了一波关注，两条线一冷一热。",
    highlights: [
      "粉丝团深夜发长文说明同行人员身份",
      "江照为角色减重约十五斤",
      "柯屿综艺首秀紧张忘词",
    ],
    articleSlugs: [
      "tang-zhi-rumor-denied",
      "jiang-zhao-new-drama-start",
      "ke-yu-variety-debut",
      "ye-qinghe-airport-scarf",
    ],
  },
  {
    slug: "daily-2026-09-06",
    date: "2026-09-06",
    weekday: "周日",
    title: "每日合集·9月6日｜私服同款与综艺新人首秀",
    summary:
      "周末的讨论偏向生活化：叶青禾一条围巾带火小众品牌，柯屿的综艺首秀因为忘词反而圈了一波好感。",
    highlights: [
      "针织围巾同款三天售罄",
      "综艺首秀忘词片段被保留进正片",
      "本周热门盘点同步上线",
    ],
    articleSlugs: [
      "ye-qinghe-airport-scarf",
      "ke-yu-variety-debut",
      "tang-zhi-rumor-denied",
      "summer-box-office-review",
    ],
  },
  {
    slug: "daily-2026-09-05",
    date: "2026-09-05",
    weekday: "周六",
    title: "每日合集·9月5日｜暑期档复盘 + 古装新剧官宣",
    summary:
      "周六的内容偏深度：暑期档中小成本影片逆袭的原因被系统复盘，同时温可的古装新剧也正式官宣。",
    highlights: [
      "暑期档中小成本影片频频逆袭",
      "温可时隔两年再演古装",
      "点映宣发节奏成为讨论重点",
    ],
    articleSlugs: [
      "summer-box-office-review",
      "wen-ke-costume-drama-join",
      "gu-yanzhi-new-film-dingdang",
      "short-drama-new-players",
    ],
  },
  {
    slug: "daily-2026-09-04",
    date: "2026-09-04",
    weekday: "周五",
    title: "每日合集·9月4日｜周五热搜提前预演",
    summary:
      "临近周末，几条消息提前把话题热度拉了起来，从演唱会物料到新剧预告，吃瓜节奏明显加快。",
    highlights: [
      "演唱会收官站物料提前释出",
      "新剧预告片放出第一波讨论",
      "本周事件汇总开始整理",
    ],
    articleSlugs: [
      "lu-zhiyao-tour-finale",
      "gu-yanzhi-new-film-dingdang",
      "cheng-yiye-su-nian-santong-kuang",
      "baixi-variety-save-scene",
    ],
  },
];